/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   5/31/21
 */

import React from "react";
import {Avatar as MuiAvatar, useTheme} from "@mui/material";
import {useQuery} from "urql";
import {
	EmployeePictureUrlQuery,
	EmployeePictureUrlResponse,
	EmployeePictureUrlVars
} from "../graphql/queries/employees";
import {envType} from "../context/environment";

interface Props {
	id?: string
	src?: string
	size?: "xxs" | "xs" | "sm" | "lg" | "xl";
}

export default function Avatar(props: Props) {

	const [pictureResult] = useQuery<EmployeePictureUrlResponse, EmployeePictureUrlVars>({
		query: EmployeePictureUrlQuery,
		variables: {
			employees: [props.id as string]
		},
		pause: !props.id || envType !== "prod" || !!props.src
	});

	const theme = useTheme();
	let size = 5;
	switch (props.size) {
		case "xxs": size = 3; break;
		case "xs": size = 4; break;
		case "lg": size = 6; break;
		case "xl": size = 7; break;
	}
	let url = props.id && pictureResult.data?.employeePictureUrl?.[props.id];

	return (
		<MuiAvatar
			src={props.src ?? (envType !== "prod" ? `https://staff-avatars.prod.atl-paas.net/avatar/${props.id}?size=Large` : url)}
			alt={props.id}
			sx={{
				width: theme.spacing(size),
				height: theme.spacing(size)
			}}
		/>
	);

}